import DividerLine from "components/common/divider/line";
import TopHeader from "components/common/header";
import { DiscussListSkeleton } from "components/skeleton/discuss";
import { MainDiscussSkeleton } from "components/skeleton/main";
import AlarmButton from "components/templates/common/Discuss/List/AlarmButton";
import ClosedDiscuss from "components/templates/common/Discuss/List/ClosedDiscuss";
import OngoingDiscuss from "components/templates/common/Discuss/List/OngoingDiscuss";
import { useRouter } from "next/router";
import { TYPO } from "styles/Typo";
import { useDiscussListAll } from "utils/clientAPIs/discuss";

function DiscussListPage({ isMobile }: { isMobile: boolean }) {
  const router = useRouter();
  const [discussList, isLoading] = useDiscussListAll({ lite: true });
  const onGoingDiscussList = discussList?.filter(
    (discuss: any) => !discuss?.isClosed
  );
  const closedDiscussList = discussList?.filter(
    (discuss: any) => discuss?.isClosed
  );

  if (!isLoading && discussList?.length === 0) {
    return (
      <main className="min-w-[360px] max-w-[800px] w-screen bg-white min-h-screen"></main>
    );
  }

  return (
    <main className="min-w-[360px] max-w-[800px] w-screen bg-white min-h-screen mb-4">
      <TopHeader
        clickHandler={() => {
          router.push("/");
          // router.back();
        }}
      />
      {isLoading ? (
        <div>
          <DiscussListSkeleton />
        </div>
      ) : (
        <div className="flex flex-col pb-[100px]">
          {(onGoingDiscussList?.length ?? 0) > 0 && (
            <>
              <div className="px-6 pt-6">
                <span className={`${TYPO.TYPO4_SB} text-gray80`}>
                  진행중인 토론
                </span>
              </div>
              <div className="flex flex-col gap-2 py-2">
                {onGoingDiscussList.map((discuss: any, index: number) => {
                  return <OngoingDiscuss key={index} data={discuss} />;
                })}
              </div>
            </>
          )}

          {(closedDiscussList?.length ?? 0) > 0 && (
            <div>
              {(onGoingDiscussList?.length ?? 0) > 0 && (
                <DividerLine size="lg" />
              )}
              <div className="px-6 pt-6">
                <span className={`${TYPO.TYPO4_SB} text-gray80`}>
                  종료된 토론
                </span>
              </div>
              <div className="flex flex-col  gap-2 py-2">
                {closedDiscussList.map((discuss: any, index: number) => {
                  return <ClosedDiscuss key={index} data={discuss} />;
                })}
              </div>
            </div>
          )}
        </div>
      )}
      <AlarmButton isMobile={isMobile} />
    </main>
  );
}

export default DiscussListPage;
